import "./Ways.css"
import React from "react"
export default function WaysHeadImage(props) {
    return props.ModuleDetails.map((md, index) => {

        return <div className="mrtup" key={index}>
            <div
                className="picMainWay"
                style={{ backgroundColor: props.BackgroundColor }}
            >
                <div
                    className="picMainWay1"
                    style={{ backgroundColor: props.BackgroundColor }}
                >

                    <img
                        src={
                            md ? md.ImageURL : ""
                        }
                        alt={md.ImageAlt}
                        className="mail"
                    />



                </div>
            </div>{" "}
        </div>
    })
}